import ToolBarHighContrast from './ToolBarHighContrast'

export default ToolBarHighContrast
